import MyBenefits from "../../components/MyBenefits";

export default function MyBenefitsPage() {
  return <MyBenefits />;
}
